if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (window.storefrontSalesPaused && this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute("aria-disabled", "true");
          const label = this.submitButton.querySelector("span");
          if (label)
            label.textContent =
              window.storefrontSalesPausedLabel || "オープン準備中";
        }
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.saleStartsAt = Date.parse(this.dataset.saleStartsAt || "");
        this.salePending =
          this.dataset.salePending === "true" &&
          Number.isFinite(this.saleStartsAt) &&
          this.saleStartsAt > Date.now();
        if (this.salePending) this.scheduleSaleUnlock();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          window.storefrontSalesPaused ||
          this.salePending ||
          this.dataset.orderClosed === "true" ||
          this.submitButton.disabled ||
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        //Added to generate selling plan add to cart response
        const sellingPlanId = window.getCurrentSellingPlanId();
        formData.append("selling_plan", sellingPlanId);

        config.body = formData;

        window.AstalieBonus.runCartMutation(() => fetch(window.AstalieBonus.ajaxCartUrl(routes.cart_add_url), config)
          .then(async (response) => window.AstalieBonus.parseCartResponse(
            await response.text(), response.status, response.headers.get("content-type"),
          ))
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              await new Promise((resolve) => {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  this.cart.renderContents(response);
                  resolve();
                },
                { once: true },
              );
              quickAddModal.hide(true);
              });
            } else {
              this.cart.renderContents(response);
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
            });
          }))
          .catch((e) => {
            this.handleErrorMessage(e.message || window.cartStrings.error);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error && !window.storefrontSalesPaused)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            );
          });
      }

      scheduleSaleUnlock() {
        const remaining = this.saleStartsAt - Date.now();
        if (remaining <= 0) {
          window.location.reload();
          return;
        }

        window.setTimeout(
          () => this.scheduleSaleUnlock(),
          Math.min(remaining, 2147483647),
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
